import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FiCopy,
  FiUserPlus,
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiDownload,
  FiMenu,
  FiX
} from 'react-icons/fi';
import {
  BsGraphUp,
  BsPersonCheck,
  BsPeople,
  BsWallet2,
  BsStarFill
} from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { sendApiRequest } from '../utils';
import { toast } from 'react-toastify';
import { AllPartnerStages } from '../utils';

const Overview = () => {

  const [isCopied, setIsCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('account');
  const [sponserName, SetSponserName] = useState(null);
  const [CurrentMonthSelf, SetCurrentMonthSelf] = useState(0);
  const [CurrentMonthTeam, SetCurrentMonthTeam] = useState(0);
  const [PreviousMonthSelf, SetPreviousMonthSelf] = useState(0);
  const [PreviousMonthTeam, SetPreviousMonthTeam] = useState(0);
  const [previousMonthName, setPreviousMonthName] = useState('');
  const [currentNewsPage, setCurrentNewsPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [currentMonthStats, setcurrentMonthStats] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const [newsItems, setNewsItems] = useState([]);
  const userData = useSelector(state => state.user_info[0]?.user);
  const [stats, setStats] = useState({
    directStats: {
      active: 0,
      inactive: 0
    },
    teamStats: {
      active: 0,
      inactive: 0
    },
    businessStats: {
      self: 0,
      team: 0
    },
    walletStats: {
      mainWallet: 0,
      totalIncome: 0
    }
  });
  const [loading, setLoading] = useState(true);

  // Stats Data
  const statsData = [
    {
      title: 'Direct Active/Inactive',
      value: '0',
      bgColor: 'from-violet-500 to-violet-600',
      icon: <BsPersonCheck className="w-5 h-5 sm:w-6 sm:h-6" />,
      trend: 'up'
    },
    {
      title: 'Team Active/Inactive',
      value: '0',
      bgColor: 'from-orange-400 to-orange-500',
      icon: <BsPeople className="w-5 h-5 sm:w-6 sm:h-6" />,
      trend: 'up'
    },
    {
      title: 'Business Self/Team',
      value: '0',
      bgColor: 'from-red-400 to-red-500',
      icon: <BsGraphUp className="w-5 h-5 sm:w-6 sm:h-6" />,
      trend: 'up'
    },
    {
      title: 'Main Wallet/Total Income',
      value: '0',
      bgColor: 'from-cyan-400 to-cyan-500',
      icon: <BsWallet2 className="w-5 h-5 sm:w-6 sm:h-6" />,
      trend: 'down'
    },
  ];

  const fetchAndShowSponsorDetails = async (id) => {
    try {
      const response = await sendApiRequest(`api/admin/partners/sponserGet/${id}`, {}, "GET");
      if (response.data.success) {
        SetSponserName(response?.data?.data[0]?.fullName);
      }
    } catch (error) {
      console.error('Error fetching sponsor details:', error);
    }
  };

  // Effect for URL parameter
  useEffect(() => {
    if (userData?.sponsor) {
      fetchAndShowSponsorDetails(userData?.sponsor);
    }
  }, [userData?.sponsor]);

  // Account Details

  const webLink = `${process.env.REACT_APP_URL_BASE}/register?sponserID=${userData?.sponsorCode}`;

  useEffect(() => {
    const fetchNews = async () => {
      const response = await sendApiRequest('api/admin/get_all_news', {}, 'GET');
      setNewsItems(response.data.data);
    };
    fetchNews();
  }, []);

  // News Data

  // Transactions Data
  const transactions = [
    { id: 1, refUserId: '', date: '15-07-2023', description: 'Fund withdraw', amount: '9250.00' },
    { id: 2, refUserId: '', date: '01-08-2023', description: 'Fund withdraw', amount: '28300.00' },
    { id: 3, refUserId: '', date: '02-09-2023', description: 'Fund withdraw', amount: '31000.00' },
    { id: 4, refUserId: '', date: '03-10-2023', description: 'Fund withdraw', amount: '8200.00' },
    { id: 5, refUserId: '', date: '03-10-2023', description: 'Fund withdraw', amount: '3100.00' },
  ];

  const handleCopyLink = () => {
    navigator.clipboard.writeText(webLink);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const handleNewJoining = () => {
    window.open(webLink, '_blank', 'noopener,noreferrer');
  };

  // const chackandUpdateStage = async () => {
  //   try {
  //     const selfIncome = stats.businessStats.self;

  //     if (["Director", "Office Head"].includes(userData.rank)) {
  //       toast.info(`No promotion: Already at top stage "${userData.rank}".`);
  //       return;
  //     }

  //     let matchedIndex = -1;

  //     // Step 1: Find last matched stage where income >= stage.income
  //     for (let i = AllPartnerStages.length - 1; i >= 0; i--) {
  //       if (selfIncome >= AllPartnerStages[i].income) {
  //         matchedIndex = i;
  //         break;
  //       }
  //     }

  //     // Step 2: Promote to next stage (if possible)
  //     const nextIndex = matchedIndex - 1;
  //     if (nextIndex >= 0) {
  //       const nextStage = AllPartnerStages[nextIndex];

  //       // Update only if not already at nextStage
  //       if (userData.rank !== nextStage.name) {
  //         const response = await sendApiRequest(
  //           `api/admin/partners/${userData._id}`,
  //           { rank: nextStage.name },
  //           "PUT"
  //         );
  //         if (response.data.success) {
  //           toast.success(`Promoted to ${nextStage.name}`);
  //         }
  //       } else {
  //         toast.info("Already at the correct stage.");
  //       }
  //     } else {
  //       toast.info("No next stage available for promotion.");
  //     }

  //   } catch (error) {
  //     console.error("Error updating stage:", error);
  //   }
  // };


  useEffect(() => {
    if (userData?._id) {
      fetchCurrentMonthStats();
      fetchPreviousMonthStats();
    }
    // chackandUpdateStage();
  }, [userData?._id]);

  const fetchCurrentMonthStats = async () => {
    try {
      // Get current month range in **UTC** (full days)
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // 0 = January, 11 = December

      // Start: 1st of current month at 00:00:00 UTC
      const firstDay = new Date(Date.UTC(year, month, 1));

      // End: last day of current month at 23:59:59.999 UTC
      const lastDay = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 999));

      // Alternative one-liner style (very common & clean):
      // const lastDay = new Date(Date.UTC(year, month + 1, 1));
      // lastDay.setUTCMilliseconds(-1);  // rolls back to last ms of previous day

      const startDateStr = firstDay.toISOString();
      const endDateStr = lastDay.toISOString();


      // Build URL
      const response = await sendApiRequest(
        `api/overview/business-stats?startDate=${startDateStr}&endDate=${endDateStr}`,
        {},
        'GET'
      );

      if (response.status === 200) {
        const currentStats = response.data.data;
        SetCurrentMonthTeam(currentStats?.team)
        SetCurrentMonthSelf(currentStats?.self)
      }
    } catch (error) {
      console.error('Error fetching current month stats:', error);
    }
  };

  const fetchPreviousMonthStats = async () => {
    try {
      const response = await sendApiRequest(
        'api/overview/previous-month-business',
        {},
        'GET'
      );

      if (response.status === 200) {
        const previousStats = response.data.data;
        SetPreviousMonthTeam(previousStats?.team)
        SetPreviousMonthSelf(previousStats?.self)
        setPreviousMonthName(previousStats?.month || 'Previous Month')
      }
    } catch (error) {
      console.error('Error fetching previous month stats:', error);
    }
  };

  // Handle responsiveness
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);

      // Calculate items per page for news
      if (width < 640) setItemsPerPage(1);
      else if (width < 1024) setItemsPerPage(2);
      else setItemsPerPage(3);

      // Close mobile menu if screen is large
      if (width >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // News pagination
  const totalNewsPages = Math.ceil(newsItems.length / itemsPerPage);
  const currentNewsItems = newsItems.slice(
    currentNewsPage * itemsPerPage,
    (currentNewsPage + 1) * itemsPerPage
  );

  const goToNextNews = () => {
    setCurrentNewsPage((prev) => (prev + 1) % totalNewsPages);
  };

  const goToPrevNews = () => {
    setCurrentNewsPage((prev) => (prev - 1 + totalNewsPages) % totalNewsPages);
  };

  // Auto-rotate news
  useEffect(() => {
    const interval = setInterval(() => {
      goToNextNews();
    }, 8000);
    return () => clearInterval(interval);
  }, [currentNewsPage, itemsPerPage]);

  // Mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await sendApiRequest('api/overview/stats', {}, 'GET');
      if (response.data?.success) {
        setStats(response.data.data || {
          directStats: { active: 0, inactive: 0 },
          teamStats: { active: 0, inactive: 0 },
          businessStats: { self: 0, team: 0 },
          walletStats: { mainWallet: 0, totalIncome: 0 }
        });
      }
    } catch (error) {
      toast.error('Failed to fetch overview statistics');
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Header */}
      <div className="md:hidden bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Dashboard</h1>
        <button onClick={toggleMobileMenu} className="p-2">
          {isMobileMenuOpen ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="flex flex-col p-4 space-y-2">
            <button
              onClick={() => { setActiveTab('account'); setIsMobileMenuOpen(false); }}
              className={`px-4 py-2 rounded-lg font-medium text-left ${activeTab === 'account' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Account
            </button>
            <button
              onClick={() => { setActiveTab('news'); setIsMobileMenuOpen(false); }}
              className={`px-4 py-2 rounded-lg font-medium text-left ${activeTab === 'news' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              News ({newsItems.length})
            </button>
            {/* <button
              onClick={() => { setActiveTab('transactions'); setIsMobileMenuOpen(false); }}
              className={`px-4 py-2 rounded-lg font-medium text-left ${activeTab === 'transactions' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Transactions ({transactions.length})
            </button> */}
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 sm:px-6 py-6">
        {/* Header for Desktop */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="hidden md:flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8"
        >
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Dashboard Overview</h1>
            <p className="text-gray-500 mt-1">Welcome back, {userData?.fullName}</p>
          </div>
          <div className="flex gap-3">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => setActiveTab('account')}
              className={`px-4 py-2 rounded-lg font-medium ${activeTab === 'account' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Account
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => setActiveTab('news')}
              className={`px-4 py-2 rounded-lg font-medium ${activeTab === 'news' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              News ({newsItems.length})
            </motion.button>
            {/* <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => setActiveTab('transactions')}
              className={`px-4 py-2 rounded-lg font-medium ${activeTab === 'transactions' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700'}`}
            >
              Transactions ({transactions.length})
            </motion.button> */}
          </div>
        </motion.div>

        {/* Stats Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8"
        >
          {/* Direct Active/Inactive */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white p-6 rounded-lg shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Direct Team</h3>
              <BsPersonCheck className="w-6 h-6 text-blue-500" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Active</span>
                <span className="font-semibold text-green-600">{stats?.directStats?.active || 0}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Inactive</span>
                <span className="font-semibold text-red-600">{stats?.directStats?.inactive || 0}</span>
              </div>
            </div>
          </motion.div>

          {/* Team Active/Inactive */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-white p-6 rounded-lg shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Total Team</h3>
              <BsPeople className="w-6 h-6 text-orange-500" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Active</span>
                <span className="font-semibold text-green-600">{stats?.teamStats?.active || 0}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Inactive</span>
                <span className="font-semibold text-red-600">{stats?.teamStats?.inactive || 0}</span>
              </div>
            </div>
          </motion.div>

          {/* Business Self/Team */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white p-6 rounded-lg shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Total Business</h3>
              <BsGraphUp className="w-6 h-6 text-purple-500" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Self</span>
                <span className="font-semibold text-purple-600">₹{(Math.floor(stats?.businessStats?.self) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Team</span>
                <span className="font-semibold text-purple-600">₹{(Math.floor(stats?.businessStats?.team) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Total Team & Self business</span>
                <span className="font-semibold text-purple-600">₹{(Math.floor(stats?.businessStats?.team + stats?.businessStats?.self) || 0).toLocaleString()}</span>
              </div>
            </div>
          </motion.div>

          {/* Current Month Business */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white p-6 rounded-lg shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Current Month Business</h3>
              <BsGraphUp className="w-6 h-6 text-emerald-500" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Self</span>
                <span className="font-semibold text-emerald-600">₹{(Math.floor(CurrentMonthSelf) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Team</span>
                <span className="font-semibold text-emerald-600">₹{(Math.floor(CurrentMonthTeam) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Total Team & Self business</span>
                <span className="font-semibold text-emerald-600">₹{(Math.floor(CurrentMonthTeam + CurrentMonthSelf) || 0).toLocaleString()}</span>
              </div>
            </div>
          </motion.div>

          {/* Previous Month Business */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-white p-6 rounded-lg shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">{previousMonthName} Business</h3>
              <BsGraphUp className="w-6 h-6 text-amber-500" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Self</span>
                <span className="font-semibold text-amber-600">₹{(Math.floor(PreviousMonthSelf) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Team</span>
                <span className="font-semibold text-amber-600">₹{(Math.floor(PreviousMonthTeam) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Total Team & Self business</span>
                <span className="font-semibold text-amber-600">₹{(Math.floor(PreviousMonthTeam + PreviousMonthSelf) || 0).toLocaleString()}</span>
              </div>
            </div>
          </motion.div>

          {/* Main Wallet/Total Income */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white p-6 rounded-lg shadow"
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Wallet</h3>
              <BsWallet2 className="w-6 h-6 text-green-500" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Total Income</span>
                <span className="font-semibold text-green-600">₹{(Math.floor(stats?.walletStats?.mainWallet) || 0).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Remaining Amount</span>
                <span className="font-semibold text-green-600">₹{(Math.floor(stats?.walletStats?.totalIncome) || 0).toLocaleString()}</span>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Account Summary Section */}
        {activeTab === 'account' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-8 w-full max-w-4xl mx-auto"
          >
            <div className="flex items-center justify-between bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-4 sm:p-6">
              <div>
                <h2 className="text-lg sm:text-xl font-semibold">Account Summary</h2>
                <p className="text-blue-100 text-xs sm:text-sm mt-1">Your complete account details</p>
              </div>
              <span className="px-3 py-1 sm:px-4 sm:py-1.5 bg-white/20 rounded-full text-white text-xs sm:text-sm font-medium flex items-center gap-1 sm:gap-2">
                <BsStarFill className="text-yellow-300 w-3 h-3 sm:w-4 sm:h-4" />
                <span>5.M</span>
              </span>
            </div>

            <div className="p-4 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
              <div className="space-y-4 sm:space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Member ID</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">{userData?.sponsorCode}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Registration Date</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">
                      {userData?.createdAt ? new Date(userData.createdAt).toISOString().split('T')[0] : 'N/A'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Sponsor ID</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">{userData?.sponsor}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Mobile No.</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">{userData?.phone}</p>
                  </div>
                </div>
              </div>

              <div className="space-y-4 sm:space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  {/* <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Activation Package</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">₹{accountDetails.activationPackage}</p>
                  </div> */}
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Member Name</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">{userData?.fullName}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Sponsor Name</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base">{sponserName}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-500 text-xs sm:text-sm font-medium">Email ID</p>
                    <p className="font-semibold text-gray-800 text-sm sm:text-base break-all">{userData?.email}</p>
                  </div>
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <div className="space-y-3 sm:space-y-4">
                  <p className="text-gray-700 font-medium text-sm sm:text-base">Your Referral Link</p>
                  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                    <div className="flex-1 relative">
                      <input
                        type="text"
                        value={webLink}
                        readOnly
                        className="w-full p-2 sm:p-3 pr-10 text-xs sm:text-sm border border-gray-200 rounded-lg sm:rounded-xl bg-gray-50 focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
                      />
                      <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={handleCopyLink}
                        className="absolute right-2 top-2 sm:right-3 sm:top-3 text-gray-500 hover:text-blue-600 transition-colors"
                        aria-label="Copy link"
                      >
                        {isCopied ? <FiCheck className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" /> : <FiCopy className="w-4 h-4 sm:w-5 sm:h-5" />}
                      </motion.button>
                    </div>
                    <motion.button
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      onClick={handleNewJoining}
                      className="flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-lg sm:rounded-xl hover:shadow-lg transition-all duration-300 shadow-md text-sm sm:text-base"
                    >
                      <FiUserPlus className="w-4 h-4 sm:w-5 sm:h-5" />
                      <span>New Joining</span>
                    </motion.button>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}

        {/* News and Events Section */}
        {activeTab === 'news' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-8"
          >
            <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-4 sm:p-6">
              <h2 className="text-lg sm:text-xl font-semibold">News and Events</h2>
              {/* <p className="text-blue-100 text-xs sm:text-sm mt-1">
                Showing {currentNewsPage * itemsPerPage + 1}-{Math.min((currentNewsPage + 1) * itemsPerPage, newsItems.length)} of {newsItems.length} updates
              </p> */}
            </div>

            <div className="relative min-h-[250px] sm:min-h-[300px] md:min-h-[400px] px-4 sm:px-6 pb-12 sm:pb-16">
              <AnimatePresence mode="wait">
                <motion.div
                  key={newsItems}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -50 }}
                  transition={{ duration: 0.5 }}
                  className="grid gap-4 sm:gap-6 py-4 sm:py-6"
                  style={{
                    gridTemplateColumns: windowWidth < 640 ? '1fr' : windowWidth < 1024 ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                    gridTemplateRows: 'auto',
                  }}
                >
                  {newsItems.map((item) => (
                    <motion.div
                      key={item.id}
                      whileHover={{ scale: 1.01 }}
                      className="flex flex-col gap-3 sm:gap-4 p-3 sm:p-4 bg-gray-50 rounded-lg border border-gray-200 h-full"
                    >
                      <div className="flex items-center gap-2 sm:gap-3">
                        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 font-semibold">
                          {item.icon || <BsStarFill className="w-4 h-4 sm:w-5 sm:h-5" />}
                        </div>
                        <div>
                          <span className="text-xs sm:text-sm font-medium text-gray-500">
                            {item.date.split('T')[0]}
                          </span>
                          {item.isNew && (
                            <span className="ml-1 sm:ml-2 bg-red-500 text-white text-xxs sm:text-xs px-1.5 py-0.5 sm:px-2 sm:py-0.5 rounded-full">NEW</span>
                          )}
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-sm sm:text-lg font-semibold text-blue-600 mb-1 sm:mb-2">{item.title}</h3>
                        <p className="text-gray-700 text-xs sm:text-sm">
                          {item.description}
                        </p>
                      </div>
                    </motion.div>
                  ))}
                </motion.div>
              </AnimatePresence>

              {/* Navigation Controls */}
              {totalNewsPages > 1 && (
                <div className="absolute bottom-2 sm:bottom-4 left-0 right-0 flex justify-center items-center gap-3 sm:gap-4">
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={goToPrevNews}
                    className="p-1 sm:p-2 rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 shadow-sm"
                    aria-label="Previous news"
                  >
                    <FiChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                  </motion.button>

                  <div className="flex gap-1 sm:gap-2">
                    {Array.from({ length: totalNewsPages }).map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentNewsPage(index)}
                        className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all ${currentNewsPage === index ? 'bg-blue-600 scale-110' : 'bg-gray-300'}`}
                        aria-label={`Go to page ${index + 1}`}
                      />
                    ))}
                  </div>

                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={goToNextNews}
                    className="p-1 sm:p-2 rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 shadow-sm"
                    aria-label="Next news"
                  >
                    <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
                  </motion.button>
                </div>
              )}
            </div>
          </motion.div>
        )}

        {/* Transactions Section */}
        {activeTab === 'transactions' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-8"
          >
            <div className="flex items-center justify-between bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-4 sm:p-6">
              <h2 className="text-lg sm:text-xl font-semibold">Latest Transactions</h2>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr className="text-left text-gray-500 text-xs sm:text-sm font-medium border-b border-gray-200">
                    <th className="px-3 py-2 sm:px-6 sm:py-3">S.No.</th>
                    <th className="px-3 py-2 sm:px-6 sm:py-3">Ref User Id</th>
                    <th className="px-3 py-2 sm:px-6 sm:py-3">Date</th>
                    <th className="px-3 py-2 sm:px-6 sm:py-3">Description</th>
                    <th className="px-3 py-2 sm:px-6 sm:py-3 text-right">Amount</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {transactions.map((transaction) => (
                    <motion.tr
                      key={transaction.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.3 }}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 text-xs sm:text-sm">{transaction.id}</td>
                      <td className="px-3 py-2 sm:px-6 sm:py-4 text-gray-500 text-xs sm:text-sm">{transaction.refUserId || '-'}</td>
                      <td className="px-3 py-2 sm:px-6 sm:py-4 text-gray-500 text-xs sm:text-sm">{transaction.date}</td>
                      <td className="px-3 py-2 sm:px-6 sm:py-4 text-gray-500 text-xs sm:text-sm">{transaction.description}</td>
                      <td className="px-3 py-2 sm:px-6 sm:py-4 text-right font-medium text-gray-900 text-xs sm:text-sm">
                        ₹{transaction.amount}
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="p-3 sm:p-4 border-t border-gray-200 bg-gray-50 text-right">
              <motion.button
                whileHover={{ x: 3 }}
                className="text-xs sm:text-sm text-blue-600 hover:text-blue-800 font-medium"
              >
                View All Transactions →
              </motion.button>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Overview;